export default __webpack_public_path__ + "assets/audios/cfc09e40fadd36f4c57285f15df6eea6.mp3";